import { render } from "./Approve25Liquidations.vue?vue&type=template&id=0115e0bc"
import script from "./Approve25Liquidations.vue?vue&type=script&lang=js"
export * from "./Approve25Liquidations.vue?vue&type=script&lang=js"

import "./Approve25Liquidations.vue?vue&type=style&index=0&id=0115e0bc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__